import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { useFetch } from "@/lib/useFetch";
import { PageHeader, Btn, Spinner } from "@/app/ui";
import { Store } from "lucide-react";

export default function Services() {
  const { data, loading } = useFetch("/services");
  const enquire = async (id) => {
    try { const { data: r } = await api.post("/services/enquire", { service_id: id }); toast.success(r.message); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };
  if (loading) return <Spinner />;
  const items = data?.items || [];
  return (
    <div className="animate-fade-up">
      <PageHeader title="Amden Services" description="Add-on services from the Amden team to help your business grow." />
      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        {items.map((s) => (
          <div key={s.id} className="amden-card p-6 flex flex-col" data-testid={`service-${s.id}`}>
            <span className="grid place-items-center h-11 w-11 rounded-xl bg-blue-50 text-blue-accent"><Store size={22} /></span>
            <span className="text-xs px-2 py-0.5 rounded-full bg-slate-100 text-slate-500 mt-4 w-fit">{s.category}</span>
            <h3 className="mt-2 font-semibold text-navy text-lg">{s.title}</h3>
            <p className="mt-1 text-sm text-slate-500 flex-1">{s.description}</p>
            <div className="mt-4 flex items-center justify-between">
              <span className="font-mono font-semibold text-navy">From {s.price_from ? `£${s.price_from}` : "—"}</span>
              <Btn variant="accent" onClick={() => enquire(s.id)} data-testid={`service-enquire-${s.id}`}>Enquire</Btn>
            </div>
          </div>
        ))}
        {items.length === 0 && <p className="text-slate-400">No services available right now.</p>}
      </div>
    </div>
  );
}
